<template>
  <section class="form__content">
    <h3>4. {{ $t('accommodation.title') }}</h3>

    <v-form v-model="formValidation">
      <v-switch v-if="displayDoctoral"
                :label="$t('accommodation.doctoral')"
                :value="doctoral"
                @change="$emit('update:doctoral', $event)"
      />
      <v-expansion-panels v-if="displayDoctoral">
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('accommodation.doctoralRate') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <aside v-html="$t('accommodation.doctoralRateTable')"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-switch v-if="!displayDoctoral"
                :label="$t('accommodation.isArconati')"
                :value="arconati"
                @change="$emit('update:arconati', $event)"
      />

      <v-radio-group :label="$t('accommodation.arconati.label')"
                     v-if="arconati"
                     :value="arconatiChoice"
                     @change="$emit('update:arconatiChoice', $event)"
                     required
                     :rules="[v => !!v || $t('error.required')]"
      >
        <v-radio v-for="radio in radios"
                 :key="radio.value"
                 :label="radio.label"
                 :value="radio.value"
        />
      </v-radio-group>

      <v-switch :label="$t('accommodation.isMui')"
                :value="mui"
                @change="$emit('update:mui', $event)"
      >
        <template v-slot:append>
          <a href="http://www.amitel.eu/nos-residences/residence-maison-universitaire-internationale/#rates"
             target="_blank" data-bcup-haslogintext="no">{{ $t('accommodation.mui.append') }}</a>
        </template>
      </v-switch>

      <v-select v-if="mui"
                :value="muiChoice1"
                @input="$emit('update:muiChoice1', $event)"
                :items="select1Items"
      />
      <v-select v-if="mui"
                :value="muiChoice2"
                @input="$emit('update:muiChoice2', $event)"
                :items="select2Items"
      />
      <v-select v-if="mui"
                :value="muiChoice3"
                @input="$emit('update:muiChoice3', $event)"
                :items="select3Items"
      />
    </v-form>
  </section>
</template>

<script>
export default {
  name: 'Accommodation',

  props: {
    arconati: {
      required: false,
      default: false,
      type: Boolean,
    },
    arconatiChoice: {
      required: false,
      default: false,
    },
    displayDoctoral: {
      required: false,
      default: false,
    },
    doctoral: {
      required: false,
      default: false,
    },
    mui: {
      required: true,
      type: Boolean,
    },
    muiChoice1: {
      required: true,
    },
    muiChoice2: {
      required: true,
    },
    muiChoice3: {
      required: true,
    },
  },

  data () {
    return {
      formValidation: false,
      radios: [
        {
          label: this.$t('accommodation.arconati.values.arconatiSingle'),
          value: 'arconatiSingle',
        },
        {
          label: this.$t('accommodation.arconati.values.arconatiDouble'),
          value: 'arconatiDouble',
        },
        {
          label: this.$t('accommodation.arconati.values.arconatiF2'),
          value: 'arconatiF2',
        },
      ],
      selectValues: [
        { value: '-', text: this.$t('accommodation.mui.selectValues.-') },
        { value: 'classicPLS', text: this.$t('accommodation.mui.selectValues.classicPLS') },
        { value: 'classicSup', text: this.$t('accommodation.mui.selectValues.classicSup') },
        { value: 'clubPLS', text: this.$t('accommodation.mui.selectValues.clubPLS') },
        { value: 'spacePLS', text: this.$t('accommodation.mui.selectValues.spacePLS') },
        { value: 'spacePLSSup', text: this.$t('accommodation.mui.selectValues.spacePLSSup') },
        { value: 'furnishedStudio', text: this.$t('accommodation.mui.selectValues.furnishedStudio') },
        { value: 'shortTermStudio', text: this.$t('accommodation.mui.selectValues.shortTermStudio') },
      ],
    }
  },

  computed: {
    select1Items () {
      return this.selectValues.filter(value => {
        return value.value !== this.muiChoice2 && value.value !== this.muiChoice3
      })
    },
    select2Items () {
      return this.selectValues.filter(value => {
        return value.value !== this.muiChoice1 && value.value !== this.muiChoice3
      })
    },
    select3Items () {
      return this.selectValues.filter(value => {
        return value.value !== this.muiChoice1 && value.value !== this.muiChoice2
      })
    },
  },

  watch: {
    formValidation () {
      this.$emit('update:valid', this.formValidation)
    },
  },
}
</script>

<style lang="scss" scoped>
  section {
    .v-input--radio-group, .v-select {
      margin-left: 45px;
      margin-top: 0;
    }
  }
</style>
